<template>
  <div :class="['input-group',{ 'icon-valid': valid }, { 'icon-error': error }]" >
    <input
    v-if="resetToZero"
    :class="['base-input', { valid }, { error }]" value="00.000,00"  disabled/>

    <input v-if="!price && !resetToZero" v-model="priceNullable"
    :class="['base-input', { valid }, { error }]" placeholder="00.000,00" />

    <input
      v-else
      v-show="!resetToZero"
      ref="asd"
      v-bind="money"
      v-model="price"
      v-mask="stringMask"
      :id="id"
      v-money="money"
      :name="name"
      autocomplete="off"
      :class="['base-input', { valid }, { error }]"
      @input="handleInput"
      @blur="$emit('blur', $event)"
      @keyup.enter="$emit('onEnter')"
    />
  </div>
</template>
<script>
import debounce from 'lodash.debounce';
import { VMoney } from 'v-money';

export default {
  data() {
    return {
      faturamento: '',
      validacoes: {
        faturamento: false
      },
      price: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
    }
  },
  methods:{

  },
  props: {
    value: {
      type: String,
      default: null,
    },
    name:{
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false,
    },
   valid: {
      type: Boolean,
      default: false,
    },
   resetToZero: {
    type: Boolean,
    default: false
   },
   id: {
      type: String,
      default: '',
    },

    type:{
      type: String,
      default: 'text'
    },
    stringMask:{
      type: String,
      default: ''
    },
    parse: {
      type: Function,
      default: value => value,
    },
  },
    directives: {
    money: VMoney
  },
  computed: {
    handleInput() {
      return debounce((event) => {
        if (event.target) {
          this.$emit('input', this.parse(event.target.value));
        }
      }, this.debounceTime);
    },
    priceNullable: {
      get() {
        return this.price ? null : this.price;
      },
      set(val) {
        this.price = val;
      },
    },
    watch: {
    price(val) {
      if (val === 0) this.price = null;
      this.$nextTick(() => {
        if (this.$refs.asd) {
          const a = this.$refs.asd;
          a.$el.focus();
        }
      });
    },
    },
  },

}
</script>
<style lang="scss" src="./style.scss" scoped></style>
